const shopping = {
  // 添加搜索
  addSearch: `/jyhApi/historySearch/addSearch`,
  // 历史搜索记录
  searchList: `/jyhApi/historySearch/searchList`,
  // 删除搜索记录
  searchListDel: `/jyhApi/historySearch/searchListDel`,
  // 购物车配置
  shopCartConf: `/jyhApi/shoppingCart/shopCartConf`,
  // 购物车列表
  shoppingCartList: `/jyhApi/shoppingCart/shoppingCartList`,
  // 收货区服角色列表
  roleServer: `/jyhApi/Game/roleServer`,
  // 收货区服角色数量
  serverRoleNum: `/jyhApi/Game/serverRoleNum`,
  // 商品添加购物车
  shoppingCartAdd: `/jyhApi/shoppingCart/shoppingCartAdd`,
  // 删除商品
  cartGoodsDel: `/jyhApi/shoppingCart/cartGoodsDel`,
  // 修改线路角色
  deliveryRouteEdit: `/jyhApi/shoppingCart/deliveryRouteEdit`,
  // 找相似
  findLikeness: `/jyhApi/shoppingCart/findLikeness`,
  // 结算校验-异常弹窗校验-封禁等
  cartCheck: `/jyhApi/shoppingCart/cartCheck`,
  // 结算校验-收货路线校验
  buyServerCheck: `/jyhApi/shoppingCart/buyServerCheck`,
  // 结算校验-砍价校验
  bargainCheck: `/jyhApi/shoppingCart/bargainCheck`,
  // 结算校验-商品失效+收货角色失效校验
  commodityCheck: `/jyhApi/shoppingCart/commodityCheck`,
  // 结算校验-商品失效+收货角色失效校验
  orderCheck: `/jyhApi/shoppingCart/orderCheck`,
  // 下单
  orderPlace: `/jyhApi/shoppingCart/orderPlace`,
  // 购物车关联订单
  shoppingCartOrderList: `/jyhApi/shoppingCart/shoppingCartOrderList`,
  // 交易币支付
  balancePay: `/jyhApi/pay/cart/balancePay`,
  // 扫码支付
  aliPayQrcode: `/jyhApi/pay/cart/qrcode`,
  // 微信扫码支付
  wechatQrcode: `/jyhApi/pay/cart/wechat/qrcode`,
  // 支付状态获取
  orderStatus: `/jyhApi/gameapi/orderStatus`,
  // 订单列表v1
  orderList: `/jyhApi/order/listV1`,
  // 购物车订单删除
  cartOrderDel: `/jyhApi/order/cartOrderDel`,
  // 取消订单
  cancePay: `/jyhApi/order/cancePay`
};

export default shopping;
